import React from "react";

import { Box, Tab, Tabs } from "@mui/material";
import HrReviewForm from "./HrReviewForm";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import ThreeSixtyHRDashboard from "./ThreeSixtyForm/ThreeSixtyHRDashboard";
import {
  ToastVariant,
  useCustomToast,
} from "../../components/Methods/SnackBar";
import FeedBackFormHRDashboard from "./FeedBackForm/FeedBackFormHRDashboard";

const HRDashboard = () => {
  const [value, setValue] = React.useState(0);

  const showToast = useCustomToast();
  const handleShowToast = (
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = event.currentTarget.innerHTML;
    const tabLabel = tempElement.innerText;

    // Clean up the temporary element
    tempElement.remove();
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ mt: 12, mb: 10, width: "98vw" }}>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          textColor="inherit"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          <Tab {...a11yProps(0)} label="Appraisal"></Tab>
          <Tab {...a11yProps(1)} label="360 &deg;" />
          <Tab {...a11yProps(2)} label="Feedback Form" />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <HrReviewForm />
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ThreeSixtyHRDashboard />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <FeedBackFormHRDashboard />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default HRDashboard;
